export default __webpack_public_path__ + "e96b28436569c073700123c39c75c3d5.svg";